import { render, staticRenderFns } from "./channelApk1.vue?vue&type=template&id=d51e70b4&"
import script from "./channelApk1.vue?vue&type=script&lang=js&"
export * from "./channelApk1.vue?vue&type=script&lang=js&"
import style0 from "./channelApk1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports